module.exports = __webpack_public_path__ + "img/do.07d2b1ed.svg";